<jhi-modal [title]="'study-editor.study-dataset.execute-calculated-variable.choose-environment-modal.title' | translate">
    <div class="modal-body">
       @if (studyHasMultipleVariableInDatasets) {
           <ng-container *ngTemplateOutlet="multiple"></ng-container>
       } @else {
           <ng-container *ngTemplateOutlet="main"></ng-container>
       }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="backToDatasetOptionModal()">
            <span translate="back"></span>
        </button>
        @if (studyHasMultipleVariableInDatasets) {
            <button (click)="proceed()" class="btn btn-primary" data-test="modalConfirmButton" [disabled]="!isExecuteEnabled()">
                <span translate="study-editor.study-dataset.execute-calculated-variable.choose-dataset-modal.title"></span>
            </button>
        } @else {
            <button (click)="tryExecute()" class="btn btn-primary" data-test="modalConfirmButton" [disabled]="!isExecuteEnabled()">
                <span translate="study-editor.study-dataset.execute-calculated-variable.choose-dataset-modal.title"></span>
            </button>
        }

    </div>
</jhi-modal>

<ng-template #main>
    <div class="row pt-3">
        <div class="col">
            <span translate="study-editor.study-dataset.execute-calculated-variable.choose-dataset-modal.description"></span>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col">
            <span translate="study-editor.study-dataset.execute-calculated-variable.choose-dataset-modal.variable-label"></span>
        </div>
        <div class="col">
            <ng-select [items]="variables" [(ngModel)]="selectedVariable" bindLabel="name" [clearable]="false" required>
            </ng-select>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col">
            <span class="fw-bold" translate="study-editor.study-dataset.execute-calculated-variable.choose-dataset-modal.environment-select"></span>
        </div>
    </div>
    <div class="container-fluid px-0 pt-3">
        <jhi-study-instances-table-selector [studyInstanceItems]="datasetInstances" [selectAll]="true"></jhi-study-instances-table-selector>
    </div>
</ng-template>

<ng-template #multiple>
    <div class="row pt-2 pb-3">
        <div class="col">
            <span translate="study-editor.study-dataset.execute-calculated-variable.choose-dataset-modal.multiple-variable-description" [translateParams]="{param: multipleVariableNames.join(', ')}"></span>
        </div>
    </div>
    @for (item of multipleVariablesMap; track item.variable.variableName) {
        <div class="row pt-2">
            <div class="col">
               {{item.variable.variableName}}:
            </div>
            <div class="col">
                <ng-select [items]="item.variable.datasets" [(ngModel)]="inputVariableDatasetMapRequest[item.variableKey]" bindValue="id"  bindLabel="name" [clearable]="false" required>
                </ng-select>
            </div>
        </div>
    }
</ng-template>
